// default css found here:
// https://github.com/surveyjs/survey-library/blob/master/packages/survey-core/src/defaultCss/defaultCss.ts
export const customCss = {
  body: "bg-chalk-500 w-full",
  bodyContainer: "",
  container: "",
  row: "",
  rootWrapper: "bg-chalk-500",
  completedPage:
    "flex flex-col ml-auto mr-auto p-8 mt-10 rounded-lg max-w-3xl justify-center items-center bg-white",
  page: {
    root: "flex flex-col text-gray-800 gap-6 sm:p-10 p-5 my-5 rounded-lg bg-white",
    title: "",
    emptyHeaderRoot: "",
    description: "",
  },
  question: {
    mobile: "max-sm:w-full",
    mainRoot: "",
    flowRoot: "flex flex-col gap-6",
    withFrame: "",
    header: "",
    headerLeft: "flex items-center gap-2",
    headerTop: "",
    headerBottom: "",
    titleTopRoot: "flex flex-col gap-1",
    title: "font-bold text-gray-800 form-question-title",
    titleRequired: "",
    titleBar: "flex items-center gap-2",
    description: "text-sm text-gray-600",
    descriptionUnderInput: "text-xs text-gray-600 mt-1",
    footer: "mt-4 text-xs text-gray-500",
    content: "relative space-y-4",
    collapsed: "max-h-0 overflow-hidden",
    expandableAnimating: "transition-[max-height] duration-300 ease-in-out",
    expanded: "max-h-full",
    formGroup: "space-y-4",
    composite: "space-y-3",
    indent: 20,
    asCell: "",
  },
  comment: {
    root: "w-full p-3 border rounded-md text-gray-800 focus-visible:outline-none",
  },
  html: {
    root: "whitespace-normal",
  },
  paneldynamic: {
    mainRoot: "flex flex-col gap-6",
    title: "font-bold text-lg",
    button: "text-sm py-2 px-4 rounded-full",
    buttonAdd: "bg-mint-300",
    buttonRemove: "bg-red-500 text-white",
    panelsContainer: "",
    panelFooter: "flex justify-end pb-5",
    panelWrapper: "",
    footerButtonsContainer: "pt-5",
  },
  panel: {
    content: "flex flex-col gap-5",
    withFrame: "",
    title: "font-bold text-gray-800 pb-2",
    header: "",
  },
  text: {
    root: "bg-white rounded-md px-4 py-3 w-full shadow-none text-gray-800 focus-visible:outline-none",
    small: "gap-3",
    content: "border rounded-md",
    onError: "bg-white",
  },
  multipletext: {
    root: "w-full",
    content: "space-y-3",
    row: "",
    cell: "flex rounded-lg mt-1",
    itemLabel: "flex rounded-md border w-full",
    itemLabelReadOnly: "opacity-70 cursor-not-allowed",
    itemLabelDisabled: "opacity-50 cursor-not-allowed",
    itemLabelPreview: "",
    itemLabelAnswered: "",
    itemTitle:
      "px-4 inline-flex items-center min-w-fit rounded-s-md border-r border-gray-200 text-chalk-900",
    item: "flex-1",
    itemLabelOnError: "bg-white",
  },
  dropdown: {
    root: "bg-white rounded-md w-full shadow-none text-gray-800 focus-visible:outline-none",
    control:
      "flex items-center rounded-md border font-sm px-3 border-gray-200 bg-white text-gray-800 min-h-[44px]",
    controlValue: "sd-dropdown__value whitespace-normal",
    cleanButton: "hidden",
    chevronButton:
      "flex justify-center items-center h-full cursor-pointer absolute p-2 top-0 right-0 bg-white rounded-sm border-r border-y border-gray-200",
    filterStringInput: "bg-transparent absolute w-full focus-visible:outline-none",
    hintSuffix: "hidden",
  },
  matrixdropdown: {
    tableWrapper: "",
    cell: "",
    headerCell: "hidden",
    cellResponsiveTitle: "",
    rowTextCell: "",
  },
  matrixdynamic: {
    cellQuestionWrapper: "font-sm rounded-md border border-gray-200 text-gray-800",
    headerCell: "hidden sm:table-cell",
    row: "flex flex-col items-center sm:table-row",
  },
  boolean: {
    sliderText:
      "flex items-center gap-2 h-fit before:bg-[url('bare/icons/icon-check-primary.svg')] before:size-7 before:bg-no-repeat before:bg-right",
    label: "block px-10 py-2 text-gray-600",
    slider: "sd-boolean__thumb pl-5 bg-forest-50 shadow-none text-gray-800 light:bg-navy-50",
    item: "flex relative gap-1 p-2 bg-white border border-gray-600 rounded-full",
  },
  radiogroup: {
    root: "grid grid-cols-1 lg:grid-cols-2 gap-3",
    label:
      "flex items-center gap-4 min-h-10 w-full font-bold rounded-md border px-3 py-2.5 border-gray-200 bg-white text-gray-800 hover:cursor-pointer hover:bg-gray-50 radio-checked:border-forest-500 radio-checked:bg-forest-50 light:radio-checked:border-navy-500 light:radio-checked:bg-navy-50",
    materialDecorator:
      "flex items-center justify-center size-6 rounded-full border border-gray-200 radio-checked:border-2 radio-checked:ml-2 radio-checked:size-4 radio-checked:border-white radio-checked:bg-forest-500 radio-checked:ring-2 radio-checked:ring-forest-500 radio-checked:ring-offset-2 radio-checked:ring-offset-white light:radio-checked:bg-navy-500 light:radio-checked:ring-navy-500",
    itemChecked: "radio-checked",
    controlLabel: "font-bold text-gray-800",
    item: "",
  },
  actionBar: {
    root: "flex justify-end has-[#sv-nav-prev:not(.sv-action--hidden)]:justify-between pb-10 max-md:flex-col-reverse max-md:gap-5",
  },
  bodyNavigationButton: "py-5 px-8 rounded-full font-bold cursor-pointer max-md:w-full",
  navigation: {
    complete:
      "bg-forest-500 text-white hover:bg-forest-600 light:bg-navy-500 hover:light:bg-navy-600",
    prev: "border-2 border-forest-500 text-forest-500 hover:border-forest-600 light:border-navy-500 hover:light:border-navy-600 light:text-navy-500",
    next: "bg-forest-500 text-white hover:bg-forest-600 light:bg-navy-500 hover:light:bg-navy-600",
  },
};

export default customCss;
